import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { NoticeMatch } from '../../../../shared/types/routes/revisions';

function getNotices(revisionLocator: string) {
  return get<NoticeMatch[]>(`/api/revisions/${nuc(revisionLocator)}/notice-files`, true);
}

export const getUseNoticeFilesQueryKey = (revisionLocator: string): QueryKey => ['revisions', revisionLocator, 'notice-files'];

/**
 * Fetch notice files for a single revision by its locator.
 *
 * @param {string} revisionLocator - The locator of the revision to fetch. No need to call nuc before passing it in here.
 * @param {boolean} shouldFetch - Allows you to delay the fetching of the notice files.
 */
export default function useNoticeFiles(
  revisionLocator: string,
  shouldFetch = true,
) {
  return useQuery({
    queryKey: getUseNoticeFilesQueryKey(revisionLocator),
    queryFn: () => getNotices(revisionLocator),
    enabled: shouldFetch,
  });
}
